(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tabbed-collections]').forEach(function (section) {  // section = .tabbed-collections inner div
      var tabs = section.querySelectorAll('.tabbed-collections__tab');
      var grid = section.querySelector('[data-grid]');
      var exploreBtn = section.querySelector('[data-explore-btn]');
      var cache = {};

      function setActiveTab(activeTab) {
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === activeTab);
          t.setAttribute('aria-selected', t === activeTab ? 'true' : 'false');
        });
        if (exploreBtn && activeTab.dataset.tabLink) {
          exploreBtn.href = activeTab.dataset.tabLink;
        }
      }

      function loadTab(tab) {
        var handle = tab.dataset.collection;
        if (!handle) return;

        if (cache[handle]) {
          grid.innerHTML = cache[handle];
          setActiveTab(tab);
          return;
        }

        tab.setAttribute('aria-busy', 'true');
        fetch('/collections/' + handle + '?sections=tabbed-collections')
          .then(function (r) { return r.json(); })
          .then(function (json) {
            var html = json['tabbed-collections'];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-grid]');
            if (newGrid) {
              cache[handle] = newGrid.innerHTML;
              grid.innerHTML = cache[handle];
            }
            setActiveTab(tab);
          })
          .catch(function () { setActiveTab(tab); })
          .finally(function () { tab.removeAttribute('aria-busy'); });
      }

      if (tabs[0]) {
        var firstHandle = tabs[0].dataset.collection;
        if (firstHandle) cache[firstHandle] = grid.innerHTML;
        setActiveTab(tabs[0]);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (tab.classList.contains('is-active')) return;
          if (!tab.dataset.collection) return;
          loadTab(tab);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
